module.exports = __WEBPACK_EXTERNAL_MODULE_41__;


//////////////////
// WEBPACK FOOTER
// external "esri/widgets/Expand"
// module id = 41
// module chunks = 0